import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerAddress } from 'src/app/models/customer-address';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Locale } from 'src/app/models/locale';
import { GeocodeService } from 'src/app/services/geocode.service';
import { MouseEvent } from '@agm/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as _ from 'lodash';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {
  customers:Customer[] = [];
  customersTemp:Customer[] = [];
  addresses:CustomerAddress[] = [];
  address:CustomerAddress = new CustomerAddress();
  loading:Boolean = false;
  customer:Customer = new Customer();
  expand:boolean = false;
  actEditCust:boolean = true;
  actAddCust:boolean = true;
  actDeleteCust:boolean = true;
  zoom:number = 15;
  //Pagination
  public page:number = 1;
  public pagination:number = 20;
  //Searching
  public find:string = '';

  constructor(private customerServ:CustomerService, private authService:AuthService,  private modalService: NgbModal, private utl:UtilitiesService, private geoServ:GeocodeService, private toastr: ToastrManager) { }

  async ngOnInit() {
    this.actEditCust = this.authService.can("update-customer");
    this.actAddCust = this.authService.can("store-customer");
    this.actDeleteCust = this.authService.can("destroy-customer");

    this.loading = true;
    await this.getCustomers();
    this.loading = false;
  }

  async getCustomers() : Promise<void> {
    this.customers = await this.customerServ.getCustomers();
    this.filter();
    this.select();
    this.selectAddress();
  }

  filter(){
    this.utl.search(this.customers, ['id', 'name', 'comercial_name', 'rfc', 'street', 'colony', 'zip_code', 'locality', 'state'], this.find, 'id', customers => this.customersTemp = customers);
  }

  select(modal?, customer?:Customer) {
    if(customer) {
      this.customer = customer;
      if(this.customer.directions.length) {
        this.selectAddress(this.customer.directions[0]);
      } else {
        this.selectAddress();
      }
    } else {
      this.customer = new Customer();
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
    }
  }

  selectAddressModal(modal?, customer?:Customer) {
    this.customer = customer;
    if(this.customer.directions.length) {
      this.selectAddress(this.customer.directions[0]);
    } else {
      this.selectAddress();
    }

    this.modalService.open(modal, { size: 'lg', windowClass: 'bigger-max' });
  }

  mapClicked($event: MouseEvent) {
    this.address.latitude = $event.coords.lat;
    this.address.longitude = $event.coords.lng;
  }

  selectAddress(address?) : void {
    if(address) {
      this.address = address;
      this.address.latitude = Number(this.address.latitude);
      this.address.longitude = Number(this.address.longitude);
    } else {
      this.address = new CustomerAddress();
    }
  }

  locale(address:Locale) {
    this.address.city = address.ciudad;
    this.address.colony = address.asentamiento;
    this.address.locality = address.ciudad;
    this.address.state = address.estado;
    //this.address.zip_code = address.cp + "";

    this.searchAddress(address.asentamiento, address.cp, address.ciudad, address.estado);
  }

  searchAddress(colony, cp, city, state, street = "") {
    this.geoServ.geocodeAddress(street + " " + colony + ", C.P.: " + cp + ", " + city + ", " + state, 
      (lat, lon) => {
        this.address.latitude = lat;
        this.address.longitude = lon;
      });
  }

  searchAddressClick() {
    this.searchAddress(this.address.colony, this.address.zip_code, this.address.city, this.address.state, this.address.street);
  }

  async storeCustomer() : Promise<void> {
    try {
      this.loading = true;
      let customer = await this.customerServ.postCustomer(this.customer);
      this.find = '';
      await this.getCustomers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El cliente se ha creado correctamente', '', {enableHTML: true});
    } catch(e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async updateCustomer() : Promise<void> {
    try {
      this.loading = true;
      let customer = await this.customerServ.putCustomer(this.customer);
      await this.getCustomers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El cliente se ha actualizado correctamente', '', {enableHTML: true});
    } catch(e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async deleteCustomer() : Promise<void> {
    try {
      this.loading = true;
      let customer = await this.customerServ.deleteCustomer(this.customer);
      await this.getCustomers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El cliente se ha eliminado correctamente', '', {enableHTML:true});
    } catch(e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML:true});
    }
  }

  async modifyAddress() : Promise<void> {
    try {
      this.loading = true;
      if(!this.address.id) {
        this.address.customer_id = this.customer.id;
        let customer = await this.customerServ.postCustomerAddress(this.address);
      } else {
        let customer = await this.customerServ.putCustomerAddress(this.address);
      }
      await this.getCustomers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El cliente se ha actualizado correctamente', '', {enableHTML:true});
    } catch(e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML:true});
    }
  }

  async deleteAddress(): Promise<void> {
    try {
      this.loading = true;
      let address = await this.customerServ.deleteCustomerAddress(this.address);
      await this.getCustomers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El cliente se ha eliminado correctamente', '', {enableHTML:true});
    } catch(e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  toUpperCase(event){
    this.customer.rfc = String(event.target.value).toUpperCase();
  }
}
